module.exports = __webpack_public_path__ + "static/media/logo_microsoft_teams.9465716a.svg";